import useFetch from './use-fetch';

const usePopularArticles = () => {
  const data = useFetch({url: `articles/trending?sectionId=${window.Site?.targeting.sectionId}&limit=5`});

  return data;
};

export {usePopularArticles};
